/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacGemini = createLucideIcon("zodiac-gemini", [
  ["path", { d: "M16 4.525v14.948", key: "bgoxo0" }],
  ["path", { d: "M20 3A17 17 0 0 1 4 3", key: "1djemw" }],
  ["path", { d: "M4 21a17 17 0 0 1 16 0", key: "onoyo7" }],
  ["path", { d: "M8 4.525v14.948", key: "u5iyof" }]
]);

export { ZodiacGemini as default };
//# sourceMappingURL=zodiac-gemini.js.map
